import {
  MIME_TYPES,
  assetUploadSources,
} from '@packages/domains/assets/data-types';

// Lottie and Rive excluded until backend validation is in place.
// application/zip excluded from Document per reviewer guidance.
const INDEXABLE_CATEGORIES = ['Image', 'Video', 'Audio', 'Document'];

export const INDEXABLE_MIME_TYPES: string[] = Object.entries(MIME_TYPES)
  .filter(
    ([mime, {category}]) =>
      INDEXABLE_CATEGORIES.includes(category) && mime !== 'application/zip'
  )
  .map(([mime]) => mime);

// All upload sources are currently indexable. Maintaining an explicit
// allow-list so new sources require a conscious inclusion decision.
export const INDEXABLE_UPLOAD_SOURCES: string[] = [...assetUploadSources];
